








































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Funcionalidades} from '@/config/funcionalidades';
import {PermisoAccion} from '@/views/base/VariablesPermisos';
import {LoadingService} from '@/services/loadingService';
import {ComponenteBase} from '@/views/base/ComponenteBase';
import moment from 'moment/moment';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {AxiosResponse} from 'axios';
import {MSResponse} from '@/interfaces/MS';
import {actionsEvent_2} from '@/setup';
import {ICellRendererParams} from 'ag-grid-community';
import {Line} from 'vue-chartjs';
import exportMenu from "@/pantallas/Dashboard/ExportMenu.vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {Chart as ChartJs, LinearScale} from 'chart.js'
import {FlotaService} from "@/pantallas/TorreControl/ControlFlotas/flotaService";
import {InformeGraficoService} from "@/pantallas/InformeGraficoTemperatura/InformeGraficoService";


@Component({
  name: 'InformeGraficoTemperatura',
  components: {
    exportMenu,
    DatePicker,
    lineComp: Line,
  },
})
export default class InformeGraficoTemperatura extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  loadingService = new LoadingService();
  clientId: string;
  isLoading: boolean = false;
  readonly funcionalidad: Funcionalidades = Funcionalidades.Cotizador;
  dataTable: any = [];
  texto_reporte: string = '';
  showReporteGenerado: boolean = false;
  search: string = '';
  detalleSeleccionado: any = null;

  tipo_modal: string = '';

  cotizacionesList: any = [];
  idToEdit: string = '';

  dialog: boolean = false;
  id_cotizacion: string = '';
  userData: any = {};
  flotasService = new FlotaService();
  informeGraficoService = new InformeGraficoService();
  pluginOptions: any = {
    datalabels: {
      anchor: 'end',
      align: 'end',
      padding: -3,
      formatter: (val: any) => `${val}`,
      labels: {
        value: {
          color: 'black',
        },
      },
    },
  };
  formFields: any = {
    sonda: {
      label: 'Sonda',
      id: '',
      value: '',
    },
    flota: {
      label: 'Flota',
      id: '',
      value: '',
    },
    patente: {
      label: 'Patente',
      id: '',
      value: '',
    },
    fechaInicio: {
      label: 'Fecha Desde',
      id: 'desde',
      value: moment().subtract(1, 'week'),
      min: moment().subtract(1, 'week') as moment.Moment,
      maxDate: moment() as moment.Moment
    },
    fechaFin: {
      label: 'Fecha Hasta',
      id: 'hasta',
      value: moment(),
      min: moment().subtract(1, 'week') as moment.Moment,
      maxDate: moment() as moment.Moment
    },
  };
  showGraph: boolean = false
  clientData: any = {};
  patentesList: any = [];
  flotasList: any = [];
  sondasList: any = ['1', '2', '3', '4', '5', '6'];
  dataGraph: any = [];
  constructor() {
    super();
    this.getClientId();
  }

  created() {
    let self = this;
    this.userData = JSON.parse(localStorage.getItem('user'));
  }

  mounted() {
    /*let prove = {labels: ["t1", "t2"], values: [50, 30], values2: [40, 20], ref: 'Ignición'};
    (this.$refs.lineRefIgnicion as Line).renderChart(
        {
          labels: this.formatDate(prove.labels),
          datasets: [
            {
              label: 'Con Contacto',
              data: prove.values,
              borderColor: '#00FF00',
              fill: false,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          plugins: this.pluginOptions,
        }
    );*/
    this.getFlotasYPatentes();
  }

  async getFlotasYPatentes() {
    let self = this;
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
        MSResponse<any>
    > = await this.flotasService.getFlotas(this.clientId, false);
    this.isLoading = false;
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.flotasList = msResponse.data;
      this.clientData = msResponse.cliendData;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  async onChangeFlota() {
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
        MSResponse<any>
    > = await this.flotasService.getVehiculosByFlota(this.formFields.flota.value, this.clientId, this.clientData);
    this.isLoading = false;
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.patentesList = msResponse.data
      this.patentesList.sort((a: any, b: any) => {
        if (a.patente_vehiculo < b.patente_vehiculo)
          return -1;
        if (a.patente_vehiculo > b.patente_vehiculo)
          return 1;
        return 0
      });
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  async handleBuscarClick() {
    this.loadingService.showLoading();
    if (this.formFields.flota.value == '') {
      this.$snotify.error('Debe seleccionar una flota', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    if (this.formFields.patente.value == '') {
      this.$snotify.error('Debe seleccionar una patente', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    const inicio = this.formFields.fechaInicio.value;
    const fin = this.formFields.fechaFin.value;

    if (inicio.isAfter(fin)) {
      return false;
    }
    if (fin.isBefore(inicio)) {
      return false;
    }
    let cods_vehiculos = [];
    if (this.formFields.patente.value != '')
      cods_vehiculos.push(this.formFields.patente.value)
    else
      cods_vehiculos = this.patentesList.map((item: any) => item.cod_vehiculo.toString());
    let body = {
      "client": this.clientId,
      "user": "1",
      "starting_date": inicio.format('DD-MM-YYYY'),
      "starting_hour": "00:00",
      "ending_date": fin.format('DD-MM-YYYY'),
      "ending_hour": "23:59",
      "vehicles": cods_vehiculos,
      "sondas": this.formFields.sonda.value == '' ? ["1"] : [this.formFields.sonda.value]
    }
    const axiosResponse: AxiosResponse<
        MSResponse<any>
    > = await this.informeGraficoService.getDataTemperatura(body)
    this.isLoading = false;
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA === '1') {
      this.dataGraph = msResponse.data
      this.setGraphRender();
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
    }
  }

  setGraphRender() {
    let labels: any[] = [];
    let values1: any[] = [];
    let values2: any[] = [];
    let values3: any[] = [];
    let values4: any[] = [];
    let values5: any[] = [];
    let values6: any[] = [];
    let dataFiltered = this.procesarDatosPorMediaHora();
    // let dataFiltered = this.dataGraph
    dataFiltered.forEach((item: any) => {
      labels.push(item['fecha_evento']);
      if (this.formFields.sonda.value != '' && this.formFields.sonda.value != null) {
        if (item[`temperatura_sonda_${this.formFields.sonda.value}`] != '')
          values1.push(`${item[`temperatura_sonda_${this.formFields.sonda.value}`]}`)
      } else {
        if (item['temperatura_sonda_1'] != '')
          values1.push(`${item[`temperatura_sonda_1`]}`)
        if (item['temperatura_sonda_2'] != '')
          values2.push(`${item[`temperatura_sonda_2`]}`)
        if (item['temperatura_sonda_3'] != '')
          values3.push(`${item[`temperatura_sonda_3`]}`)
        if (item['temperatura_sonda_4'] != '')
          values4.push(`${item[`temperatura_sonda_4`]}`)
        if (item['temperatura_sonda_5'] != '')
          values5.push(`${item[`temperatura_sonda_5`]}`)
        if (item['temperatura_sonda_6'] != '')
          values6.push(`${item[`temperatura_sonda_6`]}`)
      }
    })
    let dataSets = []
    console.log(values1);
    if (this.formFields.sonda.value != '') {
      if (values1.length > 0) {
        dataSets.push({
          label: 'Sonda 1',
          data: values1,
          borderColor: '#c5021d',
          fill: false,
        })
      }
    } else {
      if (values1.length > 0) {
        dataSets.push({
          label: 'Sonda 1',
          data: values1,
          borderColor: '#00FF00',
          fill: false,
        })
      }
      if (values2.length > 0) {
        dataSets.push({
          label: 'Sonda 2',
          data: values2,
          borderColor: '#c5021d',
          fill: false,
        })
      }
      if (values3.length > 0) {
        dataSets.push({
          label: 'Sonda 3',
          data: values3,
          borderColor: '#efe13c',
          fill: false,
        })
      }
      if (values4.length > 0) {
        dataSets.push({
          label: 'Sonda 4',
          data: values4,
          borderColor: '#ec523c',
          fill: false,
        })
      }
      if (values5.length > 0) {
        dataSets.push({
          label: 'Sonda 5',
          data: values5,
          borderColor: '#0240c5',
          fill: false,
        })
      }
      if (values6.length > 0) {
        dataSets.push({
          label: 'Sonda 6',
          data: values6,
          borderColor: '#7808b0',
          fill: false,
        })
      }
    }
    console.log(labels);
    if (dataSets.length > 0) {
      (this.$refs.lineRefIgnicion as Line).renderChart(
          {
            labels: labels,
            datasets: dataSets,
          },
          {
            responsive: true,
            maintainAspectRatio: false,
            plugins: this.pluginOptions,
          }
      );
      this.showGraph = true;
    } else {
      (this.$refs.lineRefIgnicion as Line).renderChart(
          {
            labels: [],
            datasets: [],
          },
          {
            responsive: true,
            maintainAspectRatio: false,
            plugins: this.pluginOptions,
          }
      );
      this.$snotify.warning('No se encontraron registros de las sondas', {
        timeout: 3000,
      });
      this.showGraph = false;
    }
    this.loadingService.hideLoading();
  }

  procesarDatosPorMediaHora() {
    const resultado: any[] = [];
    let ultimoRegistroValido: any = null;

    let timeDivider = 0;

    if (this.dataGraph.length > 80000){
      timeDivider = 60;
    }else if (this.dataGraph.length > 40000){
      timeDivider = 30
    }else {
      timeDivider = 15
    }

    for (let i = 0; i < this.dataGraph.length; i++) {
      const registroActual = this.dataGraph[i];

      if (registroActual && registroActual.fecha_evento) {
        const fechaActual = new Date(registroActual.fecha_evento);

        if (ultimoRegistroValido && ultimoRegistroValido.fecha_evento) {
          const fechaUltimoRegistro = new Date(ultimoRegistroValido.fecha_evento);
          const diferenciaMinutos = (fechaActual.getTime() - fechaUltimoRegistro.getTime()) / (1000 * timeDivider);

          if (diferenciaMinutos >= 30) {
            resultado.push(registroActual);
            ultimoRegistroValido = registroActual;
          }
        } else {
          // Si no hay un último registro válido, asume el actual como válido
          ultimoRegistroValido = registroActual;
          resultado.push(registroActual);
        }
      }
    }
    return resultado
  };

  formatDate(list: any) {
    return list.map(function (num: any) {
      return num.split(' ')[0];
    });
  }

  handleModal(tipo: string) {
    this.$router.push('/Temperatura/generar_informe');
  }

  getClientId() {
    this.clientId = localStorage.getItem('clienteDefecto');
  }

  clearAutocomplete(input: string) {
    if (this.formFields[input].value == undefined)
      this.formFields[input].value = '';
    this.onChangeFlota();
  }

  clearFilters() {
    for (let key in this.formFields) {
      if (this.formFields.hasOwnProperty(key)) {
        if (key == 'fechaInicio') {
          this.formFields[key].value = moment().subtract(1, 'month');
        } else if (key == 'fechaFin') {
          this.formFields[key].value = moment();
        } else {
          this.formFields[key].value = '';
        }
      }
    }
    this.patentesList = [];
    this.dataGraph = [];
    (this.$refs.lineRefIgnicion as Line).renderChart(
        {
          labels: [],
          datasets: [],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          plugins: this.pluginOptions,
        }
    );
  }
}
